import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';

import {
  alertNotification,
} from '../shared/store/actions';
import {
  sharedActions,
} from './store/actions';
import { slAccountsSelector } from './store/selectors';

import { AlertMessages, LIFECYCLE_REGEXP } from './constants';
import { AdminColumnPropType, SlAdminAccountsPropTypes } from './propTypes';

class AdminColumnRenderer extends PureComponent {
  static propTypes = {
    slAdminAccounts: SlAdminAccountsPropTypes.isRequired,
    value: AdminColumnPropType.isRequired,

    showAddAndEdit: PropTypes.func.isRequired,
    showDelete: PropTypes.func.isRequired,
    showAlert: PropTypes.func.isRequired,
    rowIndex: PropTypes.number.isRequired,
  };

  showSlAccountsModalForAddAndEdit = () => {
    const { value, showAddAndEdit } = this.props;

    showAddAndEdit(value);
  };

  showSlAccountsModalForDelete = () => {
    const { slAdminAccounts, value, showDelete, showAlert, rowIndex } = this.props;

    if (value.slGlJournalExists) {
      return showAlert(AlertMessages.SlGlJournalExists);
    }

    if (LIFECYCLE_REGEXP.test(value.slAccount)
      && slAdminAccounts.find(({ lifecycleMap }) => lifecycleMap === value.slAccount)) {
      return showAlert(AlertMessages.LifecycleExists);
    }

    return showDelete({ entity: value, rowIndex });
  };

  render() {
    return (
      <div>
        <button
          className="cell-icon-button"
          title="Edit Account"
          onClick={this.showSlAccountsModalForAddAndEdit}
        >
          <PencilIcon size={16} className="cell-icon" />
        </button>
        <button
          className="cell-icon-button"
          title="Delete Account"
          onClick={this.showSlAccountsModalForDelete}
        >
          <TrashIcon size={16} className="cell-icon" />
        </button>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  slAdminAccounts: slAccountsSelector(state),
});

export default connect(mapStateToProps, {
  showAddAndEdit: sharedActions.showModalForAddEdit,
  showDelete: sharedActions.showModalForRemove,
  showAlert: alertNotification,
})(AdminColumnRenderer);
